<div class="agent-catalogs-container">
  <ng-container *ngIf="catalogs.length">
    <div class="scrollable-content-wrapper">
      <!-- Product Preferences -->
      <div class="preferences-section">
        <div class="section-title">
          {{ "agent.single_agent.catalogs.product_preferences" | translate }}
        </div>
        <!-- Whitelisted products -->
        <div class="preference-card whitelisted">
          <div class="preference-header">
            <span class="preference-icon">
              <app-svg-icon svgIcon="thumb-up-cc"></app-svg-icon>
            </span>
            <div style="display: flex; flex-direction: column; gap: 8px">
              <div class="preference-title">
                {{
                  "agent.single_agent.catalogs.whitelisted_products" | translate
                }}
              </div>
              <div class="preference-desc">
                {{ "agent.single_agent.catalogs.whitelisted_desc" | translate }}
              </div>
              <!-- Whitelisted tags -->
              <div class="tags-list">
                <span
                  class="tag"
                  [class]="preference.type"
                  *ngFor="let preference of whitelistedPreferences"
                  [title]="preference.type"
                >
                  {{ preference.name }}
                  <app-svg-icon
                    svgIcon="close-cc"
                    (click)="
                      deleteConfirmation(
                        'preference',
                        null,
                        preference,
                        'whitelist'
                      )
                    "
                  ></app-svg-icon>
                </span>
              </div>
            </div>
            <button
              class="action-btn secondary-btn icon-btn"
              (click)="openProductPreferencesDialog('whitelist')"
            >
              <span class="icon">
                <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
              </span>
            </button>
          </div>
        </div>
        <!-- Blacklisted products -->
        <div class="preference-card blacklisted">
          <div class="preference-header">
            <span class="preference-icon">
              <app-svg-icon svgIcon="block-cc"></app-svg-icon>
            </span>
            <div style="display: flex; flex-direction: column; gap: 8px">
              <div class="preference-title">
                {{
                  "agent.single_agent.catalogs.blacklisted_products" | translate
                }}
              </div>
              <div class="preference-desc">
                {{ "agent.single_agent.catalogs.blacklisted_desc" | translate }}
              </div>
              <!-- Blacklist tags -->
              <div class="tags-list">
                <span
                  class="tag"
                  [class]="preference.type"
                  *ngFor="let preference of blacklistedPreferences"
                  [title]="preference.type"
                >
                  {{ preference.name }}
                  <app-svg-icon
                    svgIcon="close-cc"
                    (click)="
                      deleteConfirmation(
                        'preference',
                        null,
                        preference,
                        'blacklist'
                      )
                    "
                  ></app-svg-icon>
                </span>
              </div>
            </div>
            <button
              class="action-btn secondary-btn icon-btn"
              (click)="openProductPreferencesDialog('blacklist')"
            >
              <span class="icon">
                <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
              </span>
            </button>
          </div>
        </div>
      </div>
      <!-- Available Catalogs -->
      <div class="catalogs-section">
        <div class="section-title">
          {{ "agent.single_agent.catalogs.available_catalogs" | translate }}
        </div>
        <div class="catalogs-list">
          <div class="catalog-card" *ngFor="let catalog of catalogs">
            <div class="catalog-image">
              <img
                [src]="
                  baseUrl + catalog.image ||
                  'assets/images/catalog-placeholder.svg'
                "
                alt=""
              />
            </div>
            <div class="catalog-info">
              <div class="catalog-title-row">
                <span class="catalog-title">{{ catalog.name }}</span>
                <span class="tag" [class.positive]="catalog.status === 'Approved'">{{(catalog.status === 'Draft' ? 'Catalogs.new_catalog.publish_status.draft' : 'Catalogs.new_catalog.publish_status.active') | translate}}</span>
                <button
                  [matMenuTriggerFor]="menu"
                  class="action-btn secondary-btn icon-btn more-btn"
                >
                  <span class="icon"><mat-icon>more_vert</mat-icon></span>
                </button>
                <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
                  <!-- TODO: Uncomment when edit and share with agents are implemented -->
                  <!-- <button
                  mat-menu-item
                  class="edit-btn"
                  style="cursor: not-allowed"
                >
                  <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
                  {{ "agent.actions.edit" | translate }}
                </button>
                <button
                  mat-menu-item
                  class="share-btn"
                  style="cursor: not-allowed"
                >
                  <app-svg-icon svgIcon="share-cc"></app-svg-icon>
                  {{ "agent.actions.share_with_agents" | translate }}
                </button> -->
              <button
                mat-menu-item
                class="edit-btn"
                (click)="editCatalog(catalog)"
              >
                <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
                {{ "agent.actions.edit_catalog" | translate }}
              </button>
                  <button
                    mat-menu-item
                    class="delete-btn"
                    (click)="deleteConfirmation('catalog', catalog.id!)"
                  >
                    <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
                    {{ "agent.actions.remove_catalog" | translate }}
                  </button>
                </mat-menu>
              </div>
              <div class="catalog-desc">--</div>
              <div class="catalog-stats">
                <div class="stat-item">
                  <span class="stat-label">{{
                    "quotations_and_orders.skus" | translate
                  }}</span>
                  <span class="stat-value"
                    >{{ catalog.nbr_products || 0 }}
                  </span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">{{
                    "agent.listing.orders" | translate
                  }}</span>
                  <span class="stat-value">
                    {{ catalog.total_orders }}
                  </span>
                </div>
                <!-- <div class="stat-item">
                  <span class="stat-label">{{
                    "Catalogs.discount" | translate
                  }}</span>
                  <span class="stat-value">
                    {{
                      catalog.general_discount
                        ? "-" + catalog.general_discount
                        : 0
                    }}%
                    <span
                      class="stat-label"
                      style="font-weight: 400; font-size: 14px"
                      >{{
                        "agent.single_agent.catalogs.on_msrp" | translate
                      }}</span
                    >
                  </span>
                </div> -->
                <!-- <div class="stat-item">
                  <span class="stat-label">{{
                    "agent.single_agent.catalogs.units" | translate
                  }}</span>
                  <span class="stat-value">{{ catalog.units || 0 }}</span>
                </div> -->
                <div class="stat-item">
                  <span class="stat-label">
                    {{ "agent.single_agent.catalogs.amount" | translate }}
                  </span>
                  <span class="stat-value">
                    {{
                      catalog.total_amount
                        ? catalog.total_amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })
                        : 0
                    }}
                    €
                  </span>
                </div>
                <div class="stat-item">
                  <!-- TODO: Enable when commissions are implemented -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="catalogs.length === 0">
    <div class="no-data-container">
      <img src="assets/images/bloc-note.svg" alt="" />
      <span class="no-data-msg">
        {{ "agent.single_agent.catalogs.no_data_msg" | translate }}
      </span>
      <p
        class="no-data-desc"
        [innerHTML]="'agent.single_agent.catalogs.no_data_desc' | translate"
      ></p>
      <button class="action-btn primary-btn" (click)="goToNewCatalog()">
        <span class="icon"
          ><app-svg-icon svgIcon="plus-cc"></app-svg-icon
        ></span>
        <span>{{ "agent.actions.create_catalog" | translate }}</span>
      </button>
      <button
        class="action-btn secondary-btn"
        [style.color]="'#6449DB'"
        (click)="openAddCatalogsDialog()"
      >
        <span>{{ "agent.actions.assign_catalog" | translate }}</span>
      </button>
    </div>
  </ng-container>
</div>
